import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ModalType } from './types';

export interface UsersAdminState {
  activeModal: ModalType | null;
  activeGroupeId: number | null;
}

const initialState: UsersAdminState = {
  activeModal: null,
  activeGroupeId: null
};

const groupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    changeActiveModal: (state, action: PayloadAction<ModalType | null>) => {
      state.activeModal = action.payload;
      if (action.payload === null) {
        state.activeModal = null;
      }
    },
    changeActiveGroupeId: (state, action: PayloadAction<number | null>) => {
      state.activeGroupeId = action.payload;
    },
  }
});

export const selectGroupsActiveModal = (state: RootState) => state.groups.activeModal;
export const selectActiveGroupeId = (state: RootState) => state.groups.activeGroupeId;

export const { changeActiveModal: changeGroupsActiveModal, changeActiveGroupeId } = groupsSlice.actions;
export { groupsSlice };
